<template>
  <div v-if="item" class="mt-2">
    <div class="col-12">
      <span> Click Done to acknowledge the error.</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item"]
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/action-items/types/WcaSyncError.vue